import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal text-white py-12 px-4" data-id="element-55">
      <div className="max-w-4xl mx-auto text-center" data-id="element-56">
        <p className="text-gray-400 mb-6" data-id="element-57">
          Este sitio no forma parte del sitio web de Facebook ni de Facebook
          Inc. Además, este sitio NO está respaldado por Facebook de ninguna
          manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-gray-300 mb-8" data-id="element-58">
          <a href="#" className="hover:text-white transition-colors" data-id="element-59">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-60">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-61">
            Contacto
          </a>
        </div>
        <p className="text-sm text-gray-500" data-id="element-62">
          © {new Date().getFullYear()} Recetario Saludable. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}